import { useEffect } from 'react';

export function useScrollToTop() {
  const authContent = document.getElementsByClassName('auth-content')[0];

  useEffect(() => {
    if (authContent) {
      console.log('authContent scroll to top', authContent);
      authContent.scrollTop = 0;
    }
  }, [ authContent ]);
}